<template>
  <portal-target name="expressCheckoutPortal"></portal-target>
</template>

<script>
export default {
  name: "ExpressCheckoutPortal",
}
</script>
